export default {
  layout (state, getters) {
    return state.layout
  },
  navPos (state, getters) {
    return state.layout.navPos
  },
  toolbar (state, getters) {
    return state.layout.toolbar
  },
  footer (state, getters) {
    return state.layout.footer
  },
  accountNumbers (state, getters) {
    return state.AccountNumbers
  },
  valueAccountNumber (state, getters) {
    return state.valueAccountNumber
  },
  boxed (state, getters) {
    return state.layout.boxed
  },
  roundedCorners (state, getters) {
    return state.layout.roundedCorners
  },
  viewAnimation (state, getters) {
    return state.layout.viewAnimation
  },
  isLogged (state, getters) {
    return state.logged
  },
  splashScreen (state, getters) {
    return state.splashScreen
  },
  getUser (state, getters) {
    return state.user
  },
  getAccountTypeObj (state, getters) {
    return state.accountTypeObj
  },
  getTransferAccountInfos (state, getter) {
    return state.transferAccountInfos
  },
  selectLang (state, getters) {
    return state.selectLang
  },
  getLogoutDialog (state, getters) {
    return state.logoutDialog
  },
  getSource (state, getters) {
    return state.source
  },
  getAccountInfo (state, getters) {
    return state.accountInfo
  },
  getAllAccountInfo (state, getters) {
    return state.allAccountInfo
  },
  getUsertInfo (state, getters) {
    return state.userInfo
  },
  getClientProfile (state, getters) {
    return state.clientProfile
  },
  getIdToken (state, getters) {
    return state.idToken
  },
  getAccessToken (state, getters) {
    return state.accessToken
  },
  getFilterAccountInfo(state) {
    let data = state.accountInfo.filter(item => item.tradeAccountType !== 'VA')
    return data
  },
  getAccountOpeningAgreement: state => state.accountOpeningAgreement,
  getSubBankAccounts: state => state.subBankAccounts,
  getAccountOpening: state => state.isAccountOpening,
  getFilterSPTradingAccountList: state => state.filterSPTradingAccountList

}
